import React from "react";

export default function SurveyQuestions({
  questions,
  responses,
  setResponses,
  comments,
  setComments,
  errors,
  setErrors,
}) {
  const handleResponseChange = (index, value, type = null, checked = null) => {
    const newResponses = [...responses];

    const question = questions[index];
    const isScale = question?.type === "scale";
    const num = Number(value);

    if (
      isScale &&
      (isNaN(num) || num < question.scaleMin || num > question.scaleMax)
    ) {
      setErrors((prev) => ({
        ...prev,
        [index]: `Ange ett värde mellan ${question.scaleMin} och ${question.scaleMax}`,
      }));
    } else {
      setErrors((prev) => {
        const { [index]: _, ...rest } = prev;
        return rest;
      });
    }

    if (type === "checkbox") {
      const current = newResponses[index] ? newResponses[index].split(";") : [];
      if (checked) current.push(value);
      else {
        const i = current.indexOf(value);
        if (i > -1) current.splice(i, 1);
      }
      newResponses[index] = current.join(";");
    } else {
      newResponses[index] = value;
    }

    setResponses(newResponses);
  };

  const handleCommentChange = (index, value) => {
    setComments((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

return (
  <>
    {questions.map((q, index) => (
      <div key={index} className="questionDevider">
        <p className="boldText">{`Fråga ${index + 1}`}</p>

        <div className="labelWrapper">
          <label>{q.text}</label>
        </div>

        {q.type === "text" ? (
          // <input
          //   type="text"
          //   value={responses[index] || ""}
          //   onChange={(e) => handleResponseChange(index, e.target.value)}
          // />

          <textarea
                  rows="3"
                  value={responses[index] || ""}
                  onChange={(e) => handleResponseChange(index, e.target.value)}
                />


        ) : q.type === "radio" || q.type === "checkbox" ? (
          <>
            {q.options.map((option, optionIndex) => (
              <div key={optionIndex}>
                <input
                  type={q.type}
                  name={`question-${index}`}
                  value={option}
                  checked={
                    q.type === "checkbox"
                      ? (responses[index] || "").split(";").includes(option)
                      : responses[index] === option
                  }
                  onChange={(e) =>
                    handleResponseChange(
                      index,
                      e.target.value,
                      q.type,
                      e.target.checked,
                    )
                  }
                />
                <label>{option}</label>
              </div>
            ))}

            {q.allowComment === true && (
              <div style={{ marginTop: "0.8em" }}>
                <label>
                  {q.commentLabel || "Du får gärna berätta lite mer (valfritt)"}
                </label>
                <textarea
                  rows="3"
                  value={comments[index] || ""}
                  onChange={(e) => handleCommentChange(index, e.target.value)}
                />
              </div>
            )}
          </>
        ) : q.type === "scale" ? (
          <div>
            <p className="miniP">
              Ange en siffra mellan {q.scaleMin} - {q.scaleMax}
            </p>
            <input
              type="number"
              min={q.scaleMin}
              max={q.scaleMax}
              value={responses[index] || ""}
              onChange={(e) => handleResponseChange(index, e.target.value)}
            />
            {errors[index] && (
              <p
                style={{
                  color: "red",
                  fontSize: "0.9em",
                  marginTop: "0.2em",
                }}
              >
                {errors[index]}
              </p>
            )}
            <div className="slidecontainer">
              <input
                className="slider"
                type="range"
                step="1"
                min={q.scaleMin}
                max={q.scaleMax}
                value={responses[index] ?? Math.round((q.scaleMin + q.scaleMax) / 2)}
                onChange={(e) => handleResponseChange(index, e.target.value)}
              />
            </div>
          </div>
        ) : null}
      </div>
    ))}
  </>
);
}
